/* eslint-disable no-lone-blocks */
/* eslint-disable react-hooks/exhaustive-deps */
import { useDisclosure } from '@chakra-ui/react'
import ActivityClone from './../../../components/activity-list/activity-clone/index'
import { RenderActivityInfo } from './renderActivityInfo'
import { useSharedContext } from './../../../context/shared.context'
import SelectParentAcitivity from './../../../components/select-parent-activity/index'
import { useSetPriority } from './../../../hooks/activity.hooks'
import { sharedConst } from '../../../utils/action.constant'

export const InfoDetails = props => {
	const {
		isDashboard,
		loadDetails,
		activityEnable,
		timeColor,
		onRenameActivity,
	} = props

	const {
		isOpen: isCloneActivity,
		onOpen: openCloneActivity,
		onClose: closeCloneActivity,
	} = useDisclosure()

	const {
		isOpen: isSelectParentActivity,
		onOpen: onSelectParentActivity,
		onClose: onCloseSelectParentActivity,
	} = useDisclosure()

	const {
		state: { activity },
		dispatch,
	} = useSharedContext()

	const { mutate: mutateSetPriority } = useSetPriority()

	const onSetPriority = priority => {
		mutateSetPriority(
			{
				activity_id: activity.activity_id,
				activity_enable_priority: priority,
			},
			{
				onSuccess: async res => {
					loadDetails(activity)
					dispatch({
						type: sharedConst.REFRESH_TIMELINE,
					})
					dispatch({
						type: sharedConst.REFRESH_LISTING,
					})
				},
			}
		)
	}

	const canChangePriority = () => {
		return !(
			activity?.activity_type_flag_enable_priority &&
			activityEnable() &&
			timeColor(activity.activity_datetime_end_deferred) !== 'red'
		)
	}

	return (
		<>
			<ActivityClone
				isDashboard={isDashboard}
				activity={activity}
				isOpen={isCloneActivity}
				onClose={closeCloneActivity}
			/>
			<SelectParentAcitivity
				isOpen={isSelectParentActivity}
				onClose={onCloseSelectParentActivity}
				activity={activity}
				loadDetails={loadDetails}
			/>
			<RenderActivityInfo
				openCloneActivity={openCloneActivity}
				onSelectParentActivity={onSelectParentActivity}
				onSetPriority={onSetPriority}
				canChangePriority={canChangePriority()}
				onRenameActivity={onRenameActivity}
			/>
		</>
	)
}
